import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import {
  Home,
  Renungan,
  StrukturOrganisasi,
  TentangGenesaret,
  WartaJemaat,
  Login,
  Register,
  Admin,
  Operator,
  ManageUsers,
  IbadahMinggu,
  IbadahKompelka,
  UpdateWartaTata,
  UpdateRenungan
} from "../../pages";

const AppRoutes = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/renungan" element={<Renungan />} />
        <Route path="/struktur-organisasi" element={<StrukturOrganisasi />} />
        <Route path="/tentang-genesaret" element={<TentangGenesaret />} />
        <Route path="/warta-jemaat" element={<WartaJemaat />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/operator" element={<Operator />} />
        <Route path="/admin/manage-users" element={<ManageUsers />} />
        <Route path="/operator/ibadah-minggu" element={<IbadahMinggu />} />
        <Route path="/operator/ibadah-kompelka" element={<IbadahKompelka />} />
        <Route path="/operator/update-warta-tata" element={<UpdateWartaTata />} />
        <Route path="/operator/update-renungan" element={<UpdateRenungan />} />
      </Routes>
    </Router>
  );
};
export default AppRoutes;
